import clsx from "clsx";
import React from "react";

type Props = {
  value?: boolean;
  onClick?: (value: boolean) => void;
  variant?: "primary" | "black";
  testId?: string;
};

export default function CommonSwitch({
  value,
  onClick,
  variant = "primary",
  testId,
}: Props) {
  return (
    <div
      className="p-[2px]"
      onClick={() => onClick?.(!value)}
      data-testid={`${testId}-common-switch`}
    >
      <div
        className={clsx([
          "relative rounded-full w-[44px] h-[26px] transition-all",
          {
            "bg-brand-neutral-50 pl-[1px] inactive": !value,
            "pl-[19px] active": value,
            "bg-brand-floating-primary-button": value && variant === "primary",
            "bg-black": value && variant === "black",
          },
        ])}
        data-testid={`${testId}-common-switch-children`}
      >
        <div className="h-[24px] w-[24px] bg-white rounded-full absolute top-1/2 -translate-y-1/2"></div>
      </div>
    </div>
  );
}
